import React, { useState, useEffect } from "react";
import "../css/Common.css";
import { NavLink, Link, useNavigate, useLocation } from "react-router-dom";
import logo from "../images/logo.png";
import { handleApplyNow } from "../Utils/navigation";
import { useAuth } from "../Context/AuthContext";
import { LogOut, LayoutDashboard, User } from "lucide-react";

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [showUserMenu, setShowUserMenu] = useState(false);
  const { isAuthenticated, logout } = useAuth();

  // Check if current path is home (either "/" or "/home")
  const isHomeActive = location.pathname === '/' || location.pathname === '/home';

  function showNavbar(e) {
    const navbar = document.querySelector(".header_wrapper");
    const navList = document.querySelector(".nav_list");

    if (navbar && navList) {
      navList.classList.toggle("v-class");
      navbar.classList.toggle("h-nav");
      if (navbar.classList.contains("h-nav")) {
        navbar.style.zIndex = "1";
      } else {
        navbar.style.zIndex = "2";
      }
    }
  }

  // Function to close mobile navigation when item is clicked
  const closeMobileNav = () => {
    const navbar = document.querySelector(".header_wrapper");
    const navList = document.querySelector(".nav_list");

    if (navbar && navList) {
      navList.classList.add("v-class");
      navbar.classList.remove("h-nav");
    }
  }

  // ✅ Handle repay button click – navigate directly without modal
  const handleRepayClick = () => {
    navigate("/repayloan");
  };

  // Handle logout
  const handleLogout = () => {
    showNavbar();
    setShowUserMenu(false);
    logout();
    // Clear additional localStorage items
    localStorage.removeItem("eligibility");
    localStorage.removeItem("next_step");
    localStorage.removeItem("securityAlertAccepted");
    navigate("/");
  };

  // Handle dashboard navigation
  const handleDashboardNav = () => {
    showNavbar();
    setShowUserMenu(false);
    navigate("/dashboard");
  };

  // Toggle user menu
  const toggleUserMenu = () => {
    setShowUserMenu(!showUserMenu);
  };

  // Close user menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showUserMenu && !event.target.closest('.user-menu-container')) {
        setShowUserMenu(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showUserMenu]);

  return (
    <>
      <div className="header_wrapper">
        <nav>
          <div className="logo_wrapper">
            <Link to="/">
              <img src={logo} alt="logo" />
            </Link>
          </div>
          <ul className="nav_list v-class">
            <li>
              <NavLink
                to="/home"
                onClick={showNavbar}
                className={({ isActive }) => (isActive || isHomeActive) ? 'active' : ''}
              >
                Home
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/about-us"
                onClick={showNavbar}
                className={({ isActive }) => isActive ? 'active' : ''}
              >
                About
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/contact"
                onClick={showNavbar}
                className={({ isActive }) => isActive ? 'active' : ''}
              >
                Contact
              </NavLink>
            </li>
            <div className="header-buttons">
              <li>
                {isAuthenticated ? (
                  <button
                    className="apply_now_button_link repay_loan_button"
                    onClick={() => { showNavbar(); handleRepayClick(); }}
                  >
                    Repay Now
                  </button>
                ) : (
                  <button
                    className="apply_now_button_link"
                    onClick={async () => {
                      showNavbar();
                      await handleApplyNow(navigate);
                    }}
                  >
                    Apply Now
                  </button>
                )}
              </li>

              <li>
                {isAuthenticated ? (
                  <div className="user-menu-container" style={{ position: 'relative' }}>
                    <button
                      onClick={toggleUserMenu}
                      style={{
                        width: '40px',
                        height: '40px',
                        borderRadius: '50%',
                        border: 'none',
                        backgroundColor: '#2671B7',
                        background: 'linear-gradient(135deg, #2671B7, #1e5a9a)',
                        color: '#ffffff',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        boxShadow: '0 2px 8px rgba(38, 113, 183, 0.3)',
                        transition: 'all 0.3s ease',
                        padding: 0
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.transform = 'scale(1.05)';
                        e.target.style.boxShadow = '0 4px 12px rgba(38, 113, 183, 0.4)';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.transform = 'scale(1)';
                        e.target.style.boxShadow = '0 2px 8px rgba(38, 113, 183, 0.3)';
                      }}
                    >
                      <User className="h-5 w-5" strokeWidth={2.5} />
                    </button>
                    {showUserMenu && (
                      <div style={{
                        position: 'absolute',
                        top: '100%',
                        right: 0,
                        marginTop: '8px',
                        backgroundColor: '#ffffff',
                        border: '1px solid #e5e7eb',
                        borderRadius: '8px',
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                        minWidth: '180px',
                        zIndex: 1000
                      }}>
                        {/* <button
                          onClick={handleDashboardNav}
                          style={{
                            width: '100%',
                            padding: '12px 16px',
                            textAlign: 'left',
                            border: 'none',
                            backgroundColor: 'transparent',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '10px',
                            fontSize: '14px',
                            color: '#374151',
                            transition: 'background-color 0.2s'
                          }}
                          onMouseEnter={(e) => e.target.style.backgroundColor = '#f3f4f6'}
                          onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                        >
                          <LayoutDashboard className="h-4 w-4" />
                          <span>Dashboard</span>
                        </button>
                        <div style={{
                          height: '1px',
                          backgroundColor: '#e5e7eb',
                          margin: '4px 0'
                        }}></div> */}
                        <button
                          onClick={handleLogout}
                          style={{
                            width: '100%',
                            padding: '12px 16px',
                            textAlign: 'left',
                            border: 'none',
                            backgroundColor: 'transparent',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '10px',
                            fontSize: '14px',
                            color: '#ef4444',
                            transition: 'background-color 0.2s'
                          }}
                          onMouseEnter={(e) => e.target.style.backgroundColor = '#fee2e2'}
                          onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                        >
                          <LogOut className="h-4 w-4" />
                          <span>Logout</span>
                        </button>
                      </div>
                    )}
                  </div>
                ) : (
                  <button
                    className="apply_now_button_link repay_loan_button"
                    onClick={() => { showNavbar(); handleRepayClick(); }}
                  >
                    Repay Loan
                  </button>
                )}
              </li>
              {/* <li>
  <NavLink to="#" className="apply_now_button_link repay_loan_button">
    Repay Loan
  </NavLink>
</li> */}
            </div>

          </ul>
          <div className="burger" onClick={showNavbar}>
            <div className="line"></div>
            <div className="line"></div>
            <div className="line"></div>
          </div>
        </nav>
      </div>
    </>
  );
};

export default Header;
